import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Component pages
import { CheckoutComponent } from "./checkout/checkout.component";
import { OrderConfirmComponent } from "./order-confirm/order-confirm.component";
import { MaintenanceComponent } from "./maintenance/maintenance.component";

const routes: Routes = [
  {
    path: "checkout",
    component: CheckoutComponent
  },
  {
    path: "order-confirm",
    component: OrderConfirmComponent
  },
  {
    path: "maintenance",
    component:MaintenanceComponent
  }

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ShopRoutingModule {}
